module.exports = __webpack_public_path__ + "assets/images/advancedRouteEditing-4d3d85fddb257392347b06775264e386.mp4";